{
    angular.module('interfaceModule')
        .controller('PaySuccessController',PaySuccessController);
    PaySuccessController.$inject = ['$scope',"$state",'$stateParams',"request.order",
    'utils.constant'];
    function PaySuccessController($scope,$state,$stateParams,orderRequest,
        constant) {
        let vm=this;
        let collect={
            'activate':activate,
            "qrcode":null,    //打印二维码
            'docInfo':null,
            'printInfo':null,
            'orderInfo':null,
            'gotoPreview':gotoPreview
        };
        vm.collect=collect;
        activate();

        function activate(){
            console.log('PaySuccessController');

            console.log($stateParams)    //状态参数
            orderRequest.getOrderInfo($stateParams.orderId).then(function(data){
                console.log(data);
                collect.docInfo=data.docInfo;
                collect.printInfo=data.printInfo;
                collect.orderInfo=data.orderInfo;

                setCover(collect.docInfo.docId,collect.docInfo.pageNum);
            })
            //请求得到打印二维码，返回data, data.qrcode就是二维码信息。
            orderRequest.getPrintQrcode($stateParams.orderId)
            .then(function(data){
                console.log(data);
                collect.qrcode=data.qrcode;
                console.log('这个打印二维码：' + data.qrcode);
            })
        }

        function setCover(docId,pageNum){
            let path=constant.config.sitePath+constant.config.previewPath+"/";

            if (collect.docInfo.fileName.toLowerCase().endsWith(".doc") || collect.docInfo.fileName.toLowerCase().endsWith(".docx"))
            {
                collect.docInfo.coverPath=path+"file_type_word.png";
            }
            else if (collect.docInfo.fileName.toLowerCase().endsWith(".ppt") || collect.docInfo.fileName.toLowerCase().endsWith(".pptx"))
            {
                collect.docInfo.coverPath=path+"file_type_ppt.png";
            }
            else if (collect.docInfo.fileName.toLowerCase().endsWith(".pdf"))
            {
                collect.docInfo.coverPath=path+"file_type_pdf.png";
            }
            else {
                collect.docInfo.coverPath=path+"file_type_image.png";
            }
        }
        function gotoPreview(){
            $state.go('main.preview',{'orderId':collect.orderInfo.orderId});
        }
    }
    
}